import langNewsArticle from './langs/langNewsArticle';

const NewsLangs = [langNewsArticle];

export default NewsLangs;
